/**
 * Compute the reminder color code for an appointment.
 * Only future / non-cancelled appointments emit a non-null status.
 *
 *   red    → less than 24h remaining, reminder not sent
 *   orange → between 24h and 48h remaining, reminder not sent
 *   green  → reminder already sent (and appointment is still upcoming)
 *   null   → not applicable (past, cancelled, or > 48h out)
 *
 * @param {{date:string,time:string,status?:string,reminder_sent?:boolean}} appt
 * @param {Date} [now]
 * @returns {"red"|"orange"|"green"|null}
 */
export function reminderStatus(appt, now = new Date()) {
  if (!appt || !appt.date) return null;
  if (appt.status === "cancelled") return null;

  const t = appt.time || "00:00";
  const [y, m, d] = String(appt.date).split("-").map(Number);
  const [h, mi] = String(t).split(":").map(Number);
  if (!y || !m || !d) return null;
  const start = new Date(y, (m || 1) - 1, d || 1, h || 0, mi || 0, 0, 0);

  const diffMs = start.getTime() - now.getTime();
  if (diffMs <= 0) return null; // past
  if (diffMs > 48 * 60 * 60 * 1000) return null; // > 48h out

  if (appt.reminder_sent) return "green";
  if (diffMs < 24 * 60 * 60 * 1000) return "red";
  return "orange";
}

export const REMINDER_DOT_CLASS = {
  red: "bg-red-500 ring-1 ring-red-300",
  orange: "bg-orange-500 ring-1 ring-orange-300",
  green: "bg-emerald-500 ring-1 ring-emerald-300",
};

export const REMINDER_LABEL = {
  red: "Recordatorio urgente (<24h)",
  orange: "Recordatorio pendiente (24-48h)",
  green: "Recordatorio enviado",
};
